<template>
  <div class="spinner">
    <img
      :src="require('@/assets/images/spinner--black.png')"
      :width="size"
      :height="size"
      alt=""
      class="spinner__image"
    >
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    size: {
      type: Number,
      default: 20
    }
  }
};
</script>

<style scoped lang="scss">
.spinner {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Spinner.vue